import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDashboardContext } from 'screens/dashboard/Dashboard';

/**
 * Check if the current dashboard is a custom dashboard.
 *
 * Checks:
 * - URL path matching `/dashboards/view/{uuid}` pattern.
 * - App identifier being a UUID (no dots), as opposed to system dashboards
 *   which use dot notation (e.g., "core.home", "editorial.dashboard").
 *
 * @returns {boolean} True if the current dashboard is a custom dashboard.
 */
export const useIsCustomDashboard = (): boolean => {
  const { app } = useDashboardContext();
  const location = useLocation();

  return useMemo(() => {
    // Check if URL path matches custom dashboard pattern
    const isCustomDashboardPath = location.pathname.includes('/dashboards/view/');

    // Check if app identifier is UUID format (no dots)
    const isUuidFormat = !!app && !app.includes('.');

    // A dashboard is custom if either condition is true
    return isCustomDashboardPath || isUuidFormat;
  }, [app, location.pathname]);
};
